import { externalReportsRoutes } from './external-reports.routing'
import { ExternalReportsComponent } from './external-reports.component'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { RouterModule } from '@angular/router'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SharedModule } from 'src/app/shared/shared.module'

@NgModule({
  declarations: [ExternalReportsComponent],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(externalReportsRoutes, {
      scrollPositionRestoration: 'top',
    }),
    HttpClientModule,
    SharedModule,
  ],
  exports: [ExternalReportsComponent],
})
export class ExternalReportsModule {}
